import React, {Component, ReactNode} from 'react';
import I18n from 'app/i18n';
import PlayerInterface from 'app/interfaces/poker/PlayerInterface';
import {isDesktop} from 'app/utils';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface Props {
    sitOut: () => void
    sitIn: () => void
    player: PlayerInterface
}

export default class PokerMenuButtonPause extends Component<Props> {
    functionText = (): string => {
        const {player} = this.props;

        if (isDesktop()) {
            return I18n.t(player?.sat_out ? 'poker.bet_sit_in' : 'poker.bet_sit_out');
        }
        return I18n.t(player?.sat_out ? 'poker.bet_sit_in_mobile' : 'poker.bet_sit_out_mobile');
    };

    render(): ReactNode {
        const {player, sitOut, sitIn} = this.props;

        return <button
            disabled={!player || (player?.waiting_sit_out ?? false)}
            className="poker-menu-container-button pause"
            onClick={player?.sat_out ? sitIn : sitOut}
        >
            <SpriteIcon name={player?.sat_out ? '#svg-play-icon' : '#svg-pause-icon'} className="svg-default"/>
            <span className="name">{this.functionText()}</span>
        </button>;
    }
}
